class KODialog {
  static open(id) {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    const focusTarget = dialog.querySelector('[autofocus], input, button, a');
    if (focusTarget) window.setTimeout(() => focusTarget.focus(), 50);
  }

  static close(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }
}

class KOCart {
  static async add(form) {
    const submit = form.querySelector('[type="submit"]');
    if (submit?.getAttribute('aria-busy') === 'true') return;
    if (submit) submit.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(window.KORoutes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.description || data.message);
      }
      await KOCart.refresh(true);
    } catch (error) {
      const status = form.querySelector('[data-product-form-status]');
      if (status) {
        status.textContent = error.message;
        status.hidden = false;
      }
    } finally {
      if (submit) submit.removeAttribute('aria-busy');
    }
  }

  static async refresh(openDrawer = false) {
    const response = await fetch(`${window.KORoutes.cart}?section_id=cart-drawer`);
    if (!response.ok) return;
    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const current = document.getElementById('CartDrawer');
    const replacement = documentFragment.getElementById('CartDrawer');
    if (current && replacement) current.replaceWith(replacement);
    const count = documentFragment.querySelector('[data-cart-count]');
    if (count) {
      document.querySelectorAll('[data-cart-count]').forEach((element) => {
        element.textContent = count.textContent;
      });
    }
    if (openDrawer) KODialog.open('CartDrawer');
  }

  static async change(line, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line, quantity })
    });
    if (response.ok) await KOCart.refresh(false);
  }
}

document.addEventListener('click', (event) => {
  // Cancel the native product submit before Shopify also observes the AJAX add.
  // Keep Shopify's native pixel as the sole analytics producer.
  const productSubmit = event.target.closest('[type="submit"]');
  const productForm = productSubmit?.closest('form[data-product-form]');
  if (productForm) {
    event.preventDefault();
    if (!productSubmit.disabled && productForm.reportValidity()) KOCart.add(productForm);
    return;
  }

  const opener = event.target.closest('[data-dialog-open]');
  if (opener) {
    event.preventDefault();
    KODialog.open(opener.dataset.dialogOpen);
    return;
  }

  const closer = event.target.closest('[data-dialog-close]');
  if (closer) {
    event.preventDefault();
    KODialog.close(closer.closest('dialog'));
    return;
  }

  const quantityButton = event.target.closest('[data-quantity-action]');
  if (quantityButton) {
    const wrapper = quantityButton.closest('[data-quantity]');
    const input = wrapper?.querySelector('input');
    if (!input) return;
    const step = quantityButton.dataset.quantityAction === 'increase' ? 1 : -1;
    input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  const cartRemove = event.target.closest('[data-cart-remove]');
  if (cartRemove) {
    event.preventDefault();
    KOCart.change(Number(cartRemove.dataset.line), 0);
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  KOCart.add(form);
});

document.addEventListener('change', (event) => {
  const cartInput = event.target.closest('[data-cart-line]');
  if (cartInput) KOCart.change(Number(cartInput.dataset.cartLine), Number(cartInput.value));
});

document.addEventListener('cancel', (event) => {
  if (event.target.matches('dialog')) KODialog.close(event.target);
});

document.addEventListener('click', (event) => {
  if (event.target.matches('dialog[open]')) KODialog.close(event.target);
});

const header = document.querySelector('[data-site-header]');
if (header) {
  const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}
